$(function() {
	// Set variables
	var body 		= $('body');
	var header 		= $('.new-site-header');
	var footer 		= $('.new-site-footer');
	var tablet_breakpoint = 1024;
	var mobile_breakpoint = 622;

	const header_height = header.outerHeight();

	if ( !body.hasClass('template-index') ) {

		$('.headspace').height(header_height);

	}

	function getParameterByName( name ) {
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( window.location.href );
      if( results == null )
        return "";
      else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    // Scroll up header
    $(window).scroll(function () {
    	if ($(window).scrollTop() >= 40) {
	        
	        body.addClass('scrolled');

	    } else {

	    	body.removeClass('scrolled');

	    }
    });

    // Style images on article page
	$('.j-wsiwig-imgs img').each(function(){
		if ( $(this).attr('alt') == 'half' ){
			$(this).addClass('img-half');
			$(this).parent().addClass('image-wrapper');
		}
		if ( $(this).attr('alt') == 'full' ){
			$(this).addClass('img-full');
			$(this).parent().addClass('image-wrapper');
		}
	});

	// Hero carousel

	$('.j-hero-carousel').slick({
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		swipeToSlide: true,
		fade: true
	});

	// Service blocks carousel

	$('.j-service-blocks').slick({
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth:true,
		dots: false,
		swipeToSlide: true,
		prevArrow: $('.j-sb-prev-alt'),
		nextArrow: $('.j-sb-next-alt'),
		responsive: [
			{
				breakpoint: 622,
				settings: {
					arrows: false
				}
			}
		]
	});

	// Workshops carousel

	$('.j-workshop-blocks').slick({
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth:true,
		dots: false,
		swipeToSlide: true,
		prevArrow: $('.j-ws-prev-alt'),
		nextArrow: $('.j-ws-next-alt'),
		responsive: [
			{
				breakpoint: 622,
				settings: {
					arrows: false
				}
			}
		]
	});

	// Product carousel

	$('.j-product-carousel').slick({
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth:true,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		prevArrow: $('.j-fp-prev-alt'),
		nextArrow: $('.j-fp-next-alt'),
		responsive: [
			{
				breakpoint: 622,
				settings: {
					arrows: false
				}
			}
		]
	});

	// Client logo carousel

	$('.j-client-carousel').slick({
		infinite: true,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		variableWidth:true,
		arrows: false,
		dots: false,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					centerMode: true
				}
			}
		]
	});

	// Menu toggle tablet <

	$(document).on('click', '.j-toggle-menu', function(e){

		e.preventDefault();
		body.toggleClass('menu-expanded');

	});

	// Show menu children < tablet

	$(document).on('click', '.j-show-children', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().parent().find('ul').slideToggle();

	});

	// Footer menu col trigger

	if ($(window).width() < tablet_breakpoint) {

		$(document).on('click', '.j-footer-menu-trigger', function(){

			$(this).toggleClass('active').parent().find('ul').slideToggle();

		});

	}

	// Chow category list collection < mobile

	$(document).on('click', '.j-mobile-menu-toggle', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('ul').slideToggle();

	});



	// Simple add to cart function
	function addToCart(_this){
        var variantID = _this.data('vid');
        var variantQty = _this.data('qty');
        var tags = _this.data('tags');
        var properties  = { _tags: tags };
        console.log(variantID);
        console.log(variantQty);
        console.log(properties);
        CartJS.addItem(variantID, variantQty, properties, {
            "success": function(data, textStatus, jqXHR) {
                console.log('added to basket');
                _this.html('<i class="far fa-thumbs-up"></i> Added!').addClass('pale-blue');
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('cart js Error');
                _this.html('An error occurred');
            }
        });
    }

    $(document).on('click', '.j-product-to-cart', function(e){
    	e.preventDefault();
    	var _this = $(this);
    	addToCart(_this);
    });

    $(document).on('cart.requestComplete', function(event,cart) {
        cartRequestComplete();
    });

	function cartRequestComplete() {
		console.log('cartRequestComplete');
		jQuery.getJSON('/cart.js', function(cart) {
			var cart_text = $('.j-toggle-cart span');
			if ( cart_text.length == 0 ){
				$('.j-toggle-cart').html('<span>' + cart.item_count + '</span>' );
			} else {
				cart_text.text( cart.item_count );
			}
		});
    }

    $(document).on('click', '.j-image-gallery-block', function(e){

    	e.preventDefault();

    	var image_src = $(this).data('image');
    	$('.image-lightbox .img-placehold').html('<img src="' + image_src + '">');
    	$('.image-lightbox').fadeIn();

    });

    $(document).on('click', '.j-close-image-lightbox', function(e){

    	e.preventDefault();
    	$('.image-lightbox .img-placehold').html('');
    	$('.image-lightbox').fadeOut();

    });

    // Password checker on customer register form

 //    $('#create_customer').on('submit', function(e){

	// 	var password1 = $('#CreatePassword').val();
	// 	var password2 = $('#ConfirmPassword').val();

	// 	if (password1 === password2){
	// 		console.log('true')
	// 	} else {
	// 		e.preventDefault();
	// 		$('.error-container').html('<p>Passwords do not match. Please try again.</p>')
	// 	}
	// });

	// IE11 detection
	// var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	// var IE11Warning = '<div class="browser-warning"><p>We only offer partial support for this browser. To get the best experience we recommend downloading <a href="https://www.google.com/intl/en/chrome/" target="_blank"><u>Google Chrome</u></a>.</p><span class="close-icon j-close-browser-warning"></span></div>';
	// if ( isIE11 == true ){
	// 	body.append(IE11Warning);
	// 	$(document).on('click', '.j-close-browser-warning', function(e){
	// 		$('.browser-warning').fadeOut();
	// 	});
	// }

	$('.slick-slider').show(); // Show all carousels once page loaded - must be after all slick calls
	
});